import React from 'react';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'toolsSVG',
}) => (
  <svg
    viewBox="0 0 288 267.5"
    height={height}
    width={width}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M202.7,27.6H33v169.7l63.6,42.4h169.7V68.4L202.7,27.6z M101.1,205.3l-42.4-24.7V75.4l42.4,26.1V205.3z M79.9,53.3
	l104.9,0.2l38.9,21.9H122.3L79.9,53.3z M133,208.9V102.3h106l0,106.5L133,208.9z"
    />
  </svg>
);

export default SVG;
